export default __webpack_public_path__ + "static/media/dummy-small-user.a9752091.svg";